import styled from 'styled-components';
import { colors, fontFamily, menuShadow } from '../../Utils/tokens';

export const PickerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
`;

/** "Chat AI / Chat / Input / Specialist Button" */
export const PillButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 220px;
  padding: 5px;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 999px;
  background-color: ${colors.surface};
  font-family: ${fontFamily};
  cursor: pointer;
  transition: background-color 0.15s ease;

  img {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }

  .persona {
    border-radius: 8px;
    object-fit: cover;
  }

  span {
    max-width: 175px;
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${colors.onSurface};
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chevron {
    width: 14px;
    height: 14px;
  }

  &:hover,
  &:focus-visible {
    background-color: ${colors.surfaceContainer};
    outline: none;
  }
`;

export const Dropdown = styled.div`
  position: fixed;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: 240px;
  overflow: hidden;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 6px;
  background-color: ${colors.surface};
  box-shadow: ${menuShadow};
  font-family: ${fontFamily};
`;

export const DropdownSearch = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 6px 0;
  padding: 8px 8px 8px 6px;
  border-radius: 6px;
  background-color: ${colors.secondary};

  img {
    width: 16px;
    height: 16px;
  }

  input {
    flex: 1 0 0;
    min-width: 0;
    padding: 0;
    border: none;
    outline: none;
    background: transparent;
    font-family: ${fontFamily};
    font-size: 12px;
    line-height: 16px;
    color: ${colors.onSurface};

    &::placeholder {
      color: ${colors.onSurfacePlaceholder};
    }
  }
`;

export const DropdownGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
`;

export const DropdownLabel = styled.div`
  padding: 0 6px;
  font-family: ${fontFamily};
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: ${colors.onSurfaceVariant};
`;

export const DropdownItem = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 32px;
  padding: 6px;
  border: none;
  border-radius: 6px;
  background-color: ${({ $active }) => ($active ? colors.secondary : colors.surface)};
  cursor: pointer;
  text-align: left;

  img {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    object-fit: cover;
  }

  span {
    flex: 1 0 0;
    min-width: 0;
    overflow: hidden;
    font-family: ${fontFamily};
    font-size: 12px;
    line-height: 20px;
    color: ${colors.onSurface};
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover,
  &:focus-visible {
    background-color: ${colors.surfaceContainer};
    outline: none;
  }
`;

export const ViewAllButton = styled.button`
  padding: 10px 12px;
  border: none;
  border-top: 1px solid ${colors.surfaceOutline};
  background-color: ${colors.surface};
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${colors.primary};
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;
